import Header from "./components/Header/Header"
import data from './data.json'
import { useLocation, Link } from "react-router-dom";
import './Nation.css'
import { useSelector } from 'react-redux';


const Nation = ({ location }) => {

    const mode = useSelector(state => state.mode.value)

    location = useLocation();

    const dati = location.state && location.state.dati

    const nazione = data[dati];

    return (
        <div className={mode ? 'container-dark-mode' : 'container-light-mode'}>
            <Header></Header>
            <Link to={'/flagApp'}>
                <button className={mode ? 'button-dark-mode' : 'button-light-mode'}><span class="material-symbols-outlined">
                    keyboard_backspace
                </span><b>Back</b></button>
            </Link>
            <section className={mode ? 'section-dark-mode' : 'section-light-mode'}>
                <div className="imgWrapper">
                    <img src={nazione.flag} alt='flag'></img>
                </div>
                <div className="infoWrapper">
                    <h2>{nazione.name}</h2>
                    <div className="content">
                        <div className="left">
                            <p><b>Native Name:</b> {nazione.nativeName}</p>
                            <p><b>Population:</b> {nazione.population.toLocaleString()}</p>
                            <p><b>Region:</b> {nazione.region}</p>
                            <p><b>Sub Region:</b> {nazione.subregion}</p>
                            <p><b>Capital:</b> {nazione.capital}</p>
                        </div>
                        <div className="right">
                            <p><b>Top Level Domain:</b> {nazione.topLevelDomain}</p>
                            <p><b>Currencies:</b>
                                {nazione.currencies.map((c) => {
                                    return (
                                        <p>{c.name}</p>
                                    )
                                })
                                }
                            </p>
                            <p><b>Languages:</b>
                                {nazione.languages.map((l) => {
                                    return (
                                        <p>{l.name}</p>
                                    )
                                })}
                            </p>
                        </div>
                    </div>
                    <div className="borders">
                        <p><b>Border Countries:</b> </p>
                        {nazione.borders.map((b) => {
                            return (
                                <div className="borderWrapper">
                                    <p>{b}</p>
                                </div>
                            )
                        })
                        }
                    </div>
                </div>
            </section>
        </div>
    )
}
export default Nation